import { getFirstSkuColor } from "@/components/ProductDetail/v3/ProductDetailView/utils"
import ColorSwatch from "@/components/core/ColorSwatch/ColorSwatch"
import CONSTANTS from "@/constants/index"

import Style from "@/components/MultiFinshProductBundle/styles/ColorFinishSelectorUI.module.scss"

const ColorFinishSelectorUI = props => {
  const {
    staticTexts = {},
    config = {},
    avaiableColors = [],
    swatchName,
    handleClickSwatch = () => {},
  } = props || {}

  const { colorOrFinish = "" } = staticTexts || {}

  const handleKeyDown = (i, e) => {
    const { KEYCODE } = CONSTANTS
    const ele = e.target.parentNode.childNodes
    switch (e.keyCode) {
      case KEYCODE.UP:
        if (i > 0) ele[i - 1].focus()
        break
      case KEYCODE.DOWN:
        if (i < ele.length - 1) ele[i + 1].focus()
        break
      case KEYCODE.SPACE:
      case KEYCODE.ENTER:
        ele[i].querySelector("input").click()
        break
      default:
        break
    }
  }

  const colorsData = getFirstSkuColor(avaiableColors)

  const colorsDataInfoFilter = colorsData.filter(
    colorInfo => !colorInfo.notApplicable
  )
  const colorLength = colorsDataInfoFilter.length

  return (
    <div className={Style.ColorFinishSelector}>
      {colorLength ? (
        <div className="product-colors">
          <p className="select-product">
            <span>1. </span> {colorOrFinish}
          </p>
          <p
            className="selected-color"
            tabIndex="0"
            aria-roledescription={`Finish Type ${swatchName} selected`}
          >
            {swatchName}
          </p>
        </div>
      ) : null}

      {colorLength > 0 && (
        <div className="color-finish-lists">
          <div
            id="finish-type-list"
            className="color-swatch-lists"
            role="listbox"
          >
            {colorsDataInfoFilter.map((item, i) => {
              const isChecked = item.label === swatchName

              return (
                <div
                  key={`${item?.id}-${i}`}
                  role="radio"
                  tabIndex={0}
                  aria-label={item.label}
                  aria-checked={isChecked}
                  onKeyDown={e => handleKeyDown(i, e)}
                  className={isChecked ? "bundle-selected" : ""}
                >
                  <ColorSwatch
                    type="selector"
                    id={item.id}
                    name={item.name}
                    value={item.value}
                    label={item.label}
                    colorUrl={item.colorUrl}
                    checked={isChecked}
                    onClick={() => handleClickSwatch(item.label)}
                    key={item.id + i}
                    initConfig={config}
                  />
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default ColorFinishSelectorUI
